/*
 * Copyright (c) 2023 Bolmate B.V.
 */
import './style/updates.scss';

import {CloseButton, WithBackground} from '@dvrd/dvr-controls';

import React, {Fragment, MouseEventHandler, useContext} from 'react';

import {ConditionedUpdate, PlatformUpdate} from '../../util/interfaces';

import {BolmateButton} from '../controls';

import {AppContext} from '../misc/appContext';

import Image from '../misc/image';

interface Props {
    onClose: MouseEventHandler;
    updates: PlatformUpdate[];
    active: boolean;
}

export default function Updates(props: Props) {
    const context = useContext(AppContext);
    const {onClose, updates, active} = props;

    function renderUpdate(update: PlatformUpdate, index: number) {
        return (
            <div key={index} className='update'>
                <label className='update-title'>&bull; {update.title}</label>
                {update.updates.map(renderUpdateItem)}
            </div>
        );
    }

    function renderUpdateItem(updateItem: ConditionedUpdate | React.ReactNode, index: number) {
        if (!updateItem) return null;
        if (React.isValidElement(updateItem)) return <Fragment key={index}>{updateItem}</Fragment>;
        const {user} = context.userContext;
        if ((updateItem as ConditionedUpdate).userCondition?.(user) === false) return;
        return <Fragment key={index}>{(updateItem as ConditionedUpdate).elements}</Fragment>;
    }

    return (
        <WithBackground active={active} onClose={onClose}>
            <div className='platform-updates'>
                <div className='header-container'>
                    <div style={{display: 'flex', alignItems: 'center'}}>
                        <Image name='logo-no-text' className='logo' />
                        <label className='header-title'>Bolmate updates</label>
                    </div>
                    <CloseButton onClick={onClose} />
                </div>
                <div className='body-container'>{updates.map(renderUpdate)}</div>
                <div className='footer-container'>
                    <BolmateButton onClick={onClose} label='Cool!' secondary />
                </div>
            </div>
        </WithBackground>
    );
}
